// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ma8S","largestCol":"styles_largestCol__1XGcS","smallestCol":"styles_smallestCol__3Riap"};